import { getPostContentAccess } from './posts/contentAccess';

export const resolvers = {
  Post: {
    contentAccess: getPostContentAccess,
  },
};
